export enum ESubscriptionType {
  'IMMEDIATE' = 'IMMEDIATE',
  'DIGEST_SIX' = 'DIGEST_SIX',
  'DIGEST_DAY' = 'DIGEST_DAY',
  'DIGEST_WEEK' = 'DIGEST_WEEK',
  'NONE' = 'NONE',
}
